// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { GreifCreateCartUploadModel, GreifOrderUploadModel } from "@store/Framework/Types/ApiModels";

const baseUrl = "api/v1/custom/OrderUpload";

export interface GetGreifOrderUploadApiParameter extends ApiParameter {
    greifOrderUploadParameter: GreifOrderUploadModel;
}

export async function uploadAndValidateFile(
    parameter: GetGreifOrderUploadApiParameter,
): Promise<ServiceResult<GreifOrderUploadModel>> {
    try {
        const greifOrderUploadModel = await post<GreifOrderUploadModel>(
            `${baseUrl}/validate`,
            parameter.greifOrderUploadParameter,
        );
        return {
            successful: true,
            result: greifOrderUploadModel,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
                statusCode: error.status,
            };
        }
        throw error;
    }
}

export async function uploadOrderCreateCart(): Promise<ServiceResult<GreifCreateCartUploadModel>> {
    try {
        const greifCreateCartModel = await post<GreifCreateCartUploadModel>(`${baseUrl}/createCart`);
        return {
            successful: true,
            result: greifCreateCartModel,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
                statusCode: error.status,
            };
        }
        throw error;
    }
}

export async function submitOrderUpload(
    parameter: GetGreifOrderUploadApiParameter,
): Promise<ServiceResult<GreifOrderUploadModel>> {
    try {
        const greifOrderUploadModel = await post<GreifOrderUploadModel>(
            `${baseUrl}/submit`,
            parameter.greifOrderUploadParameter,
        );
        return {
            successful: true,
            result: greifOrderUploadModel,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
